import { render, staticRenderFns } from "./PostUsers.vue?vue&type=template&id=ec3c9d58&scoped=true"
import script from "./PostUsers.vue?vue&type=script&lang=js"
export * from "./PostUsers.vue?vue&type=script&lang=js"
import style0 from "./PostUsers.vue?vue&type=style&index=0&id=ec3c9d58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3c9d58",
  null
  
)

export default component.exports